import { Component, Input, OnInit } from '@angular/core';
import { CommonUtilsService } from '../../services/commonutils/common-utils.service';

@Component({
    selector: 'app-common-templates',
    templateUrl: './common-templates.component.html',
    standalone: false,
})
export class CommonTemplatesComponent implements OnInit {
    @Input() fieldValue: any;
    @Input() valueDisplayFormat: string;

    public outputValue: string;

    constructor() {}

    ngOnChanges() {
        this.changeOutputValue();
    }

    changeOutputValue = () => {
        if (this.valueDisplayFormat && this.fieldValue) {
            this.outputValue = CommonUtilsService.formatNumber(this.fieldValue, this.valueDisplayFormat);
        } else {
            this.outputValue = this.fieldValue as any;
        }
    };

    ngOnInit() {
        this.changeOutputValue();
    }
}
